import React from 'react';

const LocationGrid = ({ gridData, selectedLocation, onLocationSelect }) => {
  if (!gridData) {
    return <div aria-busy="true" style={{ height: '150px' }}>Loading locations...</div>;
  }

  const {
    single_cell_locations,
    multi_cell_locations,
    always_unavailable_locations,
    temporarily_unavailable_locations,
    cells_occupied_by_multi_locations,
    location_assignments
  } = gridData;

  const renderedCells = new Set();

  const renderMultiCell = (key, cells) => {
    const isSelected = selectedLocation === key;
    const isAlwaysUnavailable = cells.some(cell => always_unavailable_locations.includes(cell));
    const isTemporarilyUnavailable = cells.some(cell => temporarily_unavailable_locations.includes(cell));
    const gameCount = location_assignments[key] || 0;
    const isUnavailable = isAlwaysUnavailable || isTemporarilyUnavailable;

    const cssClasses = ["location-cell", "multi-cell"];
    if (isSelected) cssClasses.push("selected");
    if (isAlwaysUnavailable) cssClasses.push("always-unavailable");
    if (isTemporarilyUnavailable) cssClasses.push("temporarily-unavailable");

    const columns = cells.map(c => c.match(/[A-Z]+/)[0].charCodeAt(0));
    const rows = cells.map(c => parseInt(c.match(/\d+/)[0], 10));
    const style = {
      gridColumn: `span ${Math.max(...columns) - Math.min(...columns) + 1}`,
      gridRow: `span ${Math.max(...rows) - Math.min(...rows) + 1}`
    };

    return (
      <div
        key={key}
        className={cssClasses.join(" ")}
        style={style}
        onClick={() => !isUnavailable && onLocationSelect(key)}
        data-location={key}
      >
        {key.replace('BIG_', '')}
        {gameCount > 0 && <span className="game-count-badge">{gameCount}</span>}
      </div>
    );
  };

  const renderSingleCell = (location) => {
    const isSelected = selectedLocation === location;
    const isAlwaysUnavailable = always_unavailable_locations.includes(location);
    const isTemporarilyUnavailable = temporarily_unavailable_locations.includes(location);
    const gameCount = location_assignments[location] || 0;
    const isUnavailable = isAlwaysUnavailable || isTemporarilyUnavailable;

    const cssClasses = ["location-cell"];
    if (isSelected) cssClasses.push("selected");
    if (isAlwaysUnavailable) cssClasses.push("always-unavailable");
    if (isTemporarilyUnavailable) cssClasses.push("temporarily-unavailable");

    return (
      <div
        key={location}
        className={cssClasses.join(" ")}
        onClick={() => !isUnavailable && onLocationSelect(location)}
        data-location={location}
      >
        {location}
        {gameCount > 0 && <span className="game-count-badge">{gameCount}</span>}
      </div>
    );
  };

  const gridItems = single_cell_locations.map(location => {
    if (renderedCells.has(location)) return null;
    const multiLocationEntry = Object.entries(multi_cell_locations).find(([_, cells]) => cells[0] === location);
    if (multiLocationEntry) {
      const [key, cells] = multiLocationEntry;
      cells.forEach(cell => renderedCells.add(cell));
      return renderMultiCell(key, cells);
    } else {
      renderedCells.add(location);
      if (cells_occupied_by_multi_locations.includes(location)) return null;
      return renderSingleCell(location);
    }
  }).filter(Boolean);

  return (
    <div className="location-grid" id="storage-location-picker">
      {gridItems}
    </div>
  );
};

export default LocationGrid;